import { UpRightArrowWhite } from "../../constants/images";
import InsightfulStar from "../../assets/insightfulStar.svg";
import insightfulStarWhite from "../../assets/insightfulStarWhite.svg";
import ServiceBanner from "../../assets/service/service-banner.png";

export default function MainHeader() {
  return (
    <div className=" header d-flex justify-content-center">
      <div className="headerBg service_container section-container ">
        <div className="textPadding">
          <h1 className="h1">Two platforms, one goal:</h1>
          <h1 className="h1">
            smarter, faster
            <span className="green-accent"> product launches</span>
            <span>.</span>
          </h1>
          <p className="Caption off-black">
            From finding the right trend to launching with confidence,
            InsightSuite™ and RegulateCPG work together to cut your
            time-to-market by 80%, boost accuracy to 96%, and eliminate the
            regulatory guesswork that slows brands down.
          </p>
        </div>
        <div className="buttonSection">
          <button
            className="btn btn-primary"
            onClick={() =>
              window.open(
                "https://connect.regulatecpg.com/regulate-book-a-demo",
                "_blank"
              )
            }
          >
            Book a Demo{" "}
            <div className="btn-icon-container">
              <img src={UpRightArrowWhite} alt="arrow" />
            </div>
          </button>
          <div className="btnOutlineMaxWidth">
            <button
              className="btn btn-outline-primary buttonText"
              onClick={() =>
                window.open(
                  "https://meetings.hubspot.com/carly-weitz/insight-suite?uuid=7d3b3785-0a66-47b0-b943-2f695b8a7120",
                  "_blank"
                )
              }
            >
              InsightSuite
              <span style={{ fontWeight: "400", marginLeft: "-0.625rem" }}>
                ™
              </span>{" "}
              Demo
              <div className="btn-icon-container">
                <img
                  src={InsightfulStar}
                  alt="Arrow"
                  className="icon-default"
                />
                <div className="btn-icon-container">
                  <img
                    src={insightfulStarWhite}
                    alt="Arrow"
                    className="icon-hover"
                  />
                </div>
              </div>
            </button>
          </div>
        </div>
        <div className="bannerBox">
          <img
            src={ServiceBanner}
            alt="banner"
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      </div>
    </div>
  );
}
